import { render, staticRenderFns } from "./RegistrationsSidebar.vue?vue&type=template&id=8193080a&scoped=true"
import script from "./RegistrationsSidebar.vue?vue&type=script&lang=js"
export * from "./RegistrationsSidebar.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsSidebar.vue?vue&type=style&index=0&id=8193080a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8193080a",
  null
  
)

export default component.exports